import QueuePage from "./QueuePage";
export default function Pembayaran() {
  return <QueuePage status="MENUNGGU_PEMBAYARAN" title="Antrean Pembayaran" description="Klaim disetujui — siap dibayar dari petty cash." testId="pembayaran-page" />;
}
